import { ReactNode, useReducer } from "react";

import { PropertiesTabContent } from "components/window/core/properties/components/PropertiesTabContent";

import { CORE_PROPERTIES_TAB_IDS } from "./constants";
import { DispatchContext, reducer, State, StateContext } from "./reducer";

export function PropertiesTabsProvider({
    children,
    initialState: customInitialState,
}: {
    children: ReactNode;
    initialState?: State;
}) {
    const effectiveInitialState = customInitialState ?? {
        tabEntries: {
            [CORE_PROPERTIES_TAB_IDS.PROPERTIES]: {
                config: {
                    id: CORE_PROPERTIES_TAB_IDS.PROPERTIES,
                    label: "properties",
                    component: PropertiesTabContent,
                },
            },
        },
    };

    const [state, dispatch] = useReducer(reducer, effectiveInitialState);

    return (
        <StateContext.Provider value={state}>
            <DispatchContext.Provider value={dispatch}>{children}</DispatchContext.Provider>
        </StateContext.Provider>
    );
}
